import Activities from "../../Activities/components/Activities";

const AuditCampaign = () => <Activities startActivityType={4}/>

export default AuditCampaign;